import { render, staticRenderFns } from "./ArticlesWarehouse.vue?vue&type=template&id=c2e03274&scoped=true"
import script from "./ArticlesWarehouse.vue?vue&type=script&lang=js"
export * from "./ArticlesWarehouse.vue?vue&type=script&lang=js"
import style0 from "./ArticlesWarehouse.vue?vue&type=style&index=0&id=c2e03274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e03274",
  null
  
)

export default component.exports